<template>
  <div class="pt20">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('teacher.back') }}</span>
    </div>
    <h4>{{ id ? $t('teacher.edit') : $t('teacher.create') }}</h4>
    <a-form :form="form" autocomplete="off" layout="vertical">
      <div class="title">{{ $t('teacher.basicInfo') }}</div>
      <div class="list">
        <a-form-item class="full" :label="$t('teacher.name')" :colon="false">
          <a-input
            maxLength="20"
            :placeholder="$t('teacher.inputName')"
            v-decorator="['name', { rules: [{ required: true, message: $t('teacher.inputName') }] }]"
          ></a-input>
        </a-form-item>
        <a-form-item :label="$t('teacher.loginAccount')" :colon="false">
          <a-input
            maxLength="13"
            :addon-after="shortName"
            :placeholder="$t('teacher.accountPlaceholder')"
            v-decorator="[
              'username',
              { rules: [{ required: true, message: $t('teacher.accountPlaceholder') }, { validator: checkName }] }
            ]"
          ></a-input>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('teacher.password')" :colon="false">
          <a-input
            maxLength="13"
            autocomplete="autocomplete"
            :type="!passwordFlag ? 'password' : 'text'"
            v-decorator="['password', { rules: [{ required: isRequired, message: $t('teacher.password') }] }]"
            :placeholder="$t('teacher.accountPlaceholder')"
          >
            <img
              @click="passwordFlag = true"
              v-if="!passwordFlag"
              src="@/assets/icons/icon_bi.png"
              slot="suffix"
              alt=""
            />
            <img @click="passwordFlag = false" v-else src="@/assets/icons/icon_kai.png" slot="suffix" alt="" />
          </a-input>
        </a-form-item>
        <a-form-item :label="$t('teacher.confirmPassword')" :colon="false">
          <a-input
            maxLength="13"
            autocomplete="autocomplete"
            :placeholder="$t('teacher.inputConfirmPassword')"
            :type="!repasswordFlag ? 'password' : 'text'"
            v-decorator="[
              'repassword',
              { rules: [{ required: isRequired, message: $t('teacher.inputConfirmPassword') }, { validator: compareToFirstPassword }] }
            ]"
          >
            <img
              @click="repasswordFlag = true"
              v-if="!repasswordFlag"
              src="@/assets/icons/icon_bi.png"
              slot="suffix"
              alt=""
            />
            <img @click="repasswordFlag = false" v-else src="@/assets/icons/icon_kai.png" slot="suffix" alt="" />
          </a-input>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('teacher.gender')" :colon="false">
          <a-select
            allowClear
            v-decorator="['gender', { rules: [{ required: true, message: $t('teacher.selectGender') }] }]"
            :placeholder="$t('teacher.selectGender')"
          >
            <a-select-option value="1">{{ $t('teacher.male') }}</a-select-option>
            <a-select-option value="2">{{ $t('teacher.female') }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="full" :label="$t('teacher.age')" :colon="false">
          <a-select
            allowClear
            v-decorator="['age', { rules: [{ required: true, message: $t('teacher.selectAge') }] }]"
            :placeholder="$t('teacher.selectAge')"
          >
            <a-select-option v-for="(item, key) in ageList" :value="item.id" :key="key">{{
              item.name
            }}</a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('teacher.educationLabel')" :colon="false">
          <a-select
            allowClear
            v-decorator="['education_id', { rules: [{ required: true, message: $t('teacher.selectEducation') }] }]"
            :placeholder="$t('teacher.selectEducation')"
          >
            <a-select-option v-for="(item, key) in educationList" :key="key" :value="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="full" :label="$t('teacher.degree')" :colon="false">
          <a-select
            allowClear
            v-decorator="['degreeId', { rules: [{ required: true, message: $t('teacher.selectDegree') }] }]"
            :placeholder="$t('teacher.selectDegree')"
          >
            <a-select-option value="1">{{ $t('teacher.degree.bachelor') }}</a-select-option>
            <a-select-option value="2">{{ $t('teacher.degree.master') }}</a-select-option>
            <a-select-option value="3">{{ $t('teacher.degree.doctor') }}</a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('teacher.rankLabel')" :colon="false">
          <a-select
            allowClear
            v-decorator="['rank_id', { rules: [{ required: true, message: $t('teacher.selectRank') }] }]"
            :placeholder="$t('teacher.selectRank')"
          >
            <a-select-option v-for="(item, key) in rankList" :key="key" :value="item.id"
              >{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="full" :label="$t('teacher.status')" :colon="false">
          <a-select
            allowClear
            v-decorator="[
              'status',
              { rules: [{ required: true, message: $t('teacher.selectStatus') }, { validator: checkAdminState }] }
            ]"
            :placeholder="$t('teacher.selectStatus')"
          >
            <a-select-option value="1">{{ $t('teacher.enable') }}</a-select-option>
            <a-select-option value="2">{{ $t('teacher.disable') }}</a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item :label="$t('teacher.birthday')" :colon="false">
          <a-date-picker
            v-decorator="['birthDate', { rules: [{ required: true, message: $t('teacher.selectBirthday') }] }]"
            :disabledDate="disabledDate"
            format="YYYY-MM-DD"
            :placeholder="$t('teacher.selectBirthday')"
          />
        </a-form-item>
        <a-form-item :label="$t('teacher.email')" :colon="false">
          <a-input
            maxLength="50"
            v-decorator="[
              'email',
              {
                rules: [{ validator: validateEmail }]
              }
            ]"
            :placeholder="$t('teacher.inputEmail')"
          />
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item :label="$t('teacher.mobile')" :colon="false">
          <a-input
            v-decorator="[
              'phone',
              {
                rules: [
                  { required: true, message: $t('teacher.inputMobile') },
                  { validator: validatePhone }
                ]
              }
            ]"
            :placeholder="$t('teacher.mobileInputTip')"
            @input="handlePhoneInput"
          />
        </a-form-item>
      </div>
      <div class="title">{{ $t('teacher.jobInfo') }}</div>
      <div class="list">
        <a-form-item :label="$t('teacher.department')" :colon="false">
          <a-input maxLength="20" v-decorator="['department']" :placeholder="$t('teacher.inputDepartment')" />
        </a-form-item>
        <a-form-item :label="$t('teacher.jobNumber')" :colon="false">
          <a-input
            maxLength="30"
            v-decorator="[
              'employeeNumber',
              {
                rules: [{ validator: validateJobNumber }]
              }
            ]"
            :placeholder="$t('teacher.inputJobNumber')"
          />
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item :label="$t('teacher.position')" :colon="false">
          <a-input maxLength="20" v-decorator="['position']" :placeholder="$t('teacher.inputPosition')" />
        </a-form-item>
        <a-form-item :label="$t('teacher.type')" :colon="false">
          <a-select
            allowClear
            v-decorator="[
              'teacherType'
            ]"
            :placeholder="$t('teacher.selectType')">
            <a-select-option value="1">{{ $t('teacher.type.regular') }}</a-select-option>
            <a-select-option value="2">{{ $t('teacher.type.contract') }}</a-select-option>
            <a-select-option value="3">{{ $t('teacher.type.substitute') }}</a-select-option>
            <a-select-option value="4">{{ $t('teacher.type.partTime') }}</a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="submit-button">
        <a-button type="primary" @click="handleSubmit">{{ $t('teacher.save') }}</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import cookie from 'js-cookie'
import moment from 'moment'

import { teacherSave, teacherDetail, teacherChangePassword, validateJobNumber } from '@/api/admin'
import md5 from 'md5'
import { getAdminOrgList, getEducationType, getRankType } from '@/api/lesson'
export default {
  data() {
    return {
      id: undefined,
      passwordFlag: true,
      repasswordFlag: true,
      passwordModal: false,
      oldpasswordFlag: false,
      noPermissionModal: false,
      passwordConfirmLoading: false,
      form: this.$form.createForm(this),
      user: cookie.getJSON('user_infor'),
      userRoles: cookie.getJSON('user_type'),
      shortName: '@' + cookie.getJSON('user_infor').username.split('@')[1],
      educationList: [],
      rankList: [],
      ageList: [],
      professionList: [],
      isRequired: true,
      // 常用邮箱后缀列表
      emailSuffixes: [
        '@qq.com',
        '@163.com',
        '@126.com',
        '@gmail.com',
        '@hotmail.com',
        '@outlook.com',
        '@yahoo.com',
        '@sina.com',
        '@sohu.com'
      ]
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'teacherList'
      })
    },
    agefn() {
      for (let i = 20; i < 101; i++) {
        this.ageList.push({
          id: i,
          name: i + this.$t('teacher.years')
        })
      }
    },
    checkName(rule, value, callback) {
      // const form = this.form
      if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
        const aa = '不支持输入中文'
        callback(aa)
      } else {
        callback()
      }
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback(this.$t('teacher.passwordNotMatch'))
      } else {
        callback()
      }
    },
    checkAdminState(rule, value, callback) {
      // const form = this.form
      if (value === '2' && this.isAdmin) {
        const error = this.$t('teacher.adminCannotBeDisabled')
        callback(error)
      } else {
        callback()
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          let pd = ''
          if (
            values.password !== '' &&
            values.password !== undefined &&
            values.repassword !== undefined &&
            values.repassword !== ''
          ) {
            pd = md5(values.password)
          } else if (
            values.password !== '' &&
            values.password !== undefined &&
            (values.repassword == undefined || values.repassword == '')
          ) {
            this.$message.error('请输入确认密码！')
            return
          } else {
            pd = ''
          }
          const data = Object.assign(values, {
            id: this.id,
            username: values.username + this.shortName,
            password: pd,
            profession_id: 0,
            department_id: 0,
            college_id: 0,
            birthDate: moment(values.birthDate).format('YYYY-MM-DD')
          })
          delete data.repassword
          // delete data.profession
          console.log('Received values of form: ', data)
          teacherSave(data).then(res => {
            console.log(data)
            if (res.code == 200) {
              const tip = this.id ? this.$t('teacher.edit') : this.$t('teacher.create')
              this.$message.success(tip + this.$t('teacher.success'))
              if (cookie.getJSON('user_infor').id === this.id) {
                const user = Object.assign(cookie.getJSON('user_infor'), {
                  name: values.name,
                  username: values.username
                })
                cookie.set('user_infor', user)
              }
              this.$router.push({
                name: 'teacherList'
              })
            }
          })
        }
      })
    },
    getTeacherDetail() {
      teacherDetail({ id: this.id }).then(res => {
        if (res.code == 200) {
          for (const key in res.data) {
            if (res.data[key] === '0') res.data[key] = undefined
          }
          this.isAdmin = res.data.isAdmin
          this.form.setFieldsValue({
            name: res.data.name,
            password: '',
            username: res.data.username.split('@')[0],
            profession: !res.data.professionId
              ? ''
              : [res.data.collegeId, res.data.departmentId, res.data.professionId],
            gender: res.data.gender,
            age: res.data.age,
            rank_id: res.data.rankId,
            education_id: res.data.educationId,
            status: res.data.status,
            phone: res.data.phone,
            birthDate: res.data.birthDate ? moment(res.data.birthDate) : undefined,
            degreeId: res.data.degreeId,
            email: res.data.email,
            employeeNumber: res.data.employeeNumber,
            position: res.data.position,
            teacherType: res.data.teacherType,
            department: res.data.department
          })
        }
      })
    },
    // 学历
    getEducationTypeHttp() {
      this.educationList = [
        {
          id: '1',
          name: this.$t('teacher.education.primary')
        },
        {
          id: '2',
          name: this.$t('teacher.education.junior')
        },
        {
          id: '3',
          name: this.$t('teacher.education.senior')
        },
        {
          id: '4',
          name: this.$t('teacher.education.college')
        },
        {
          id: '5',
          name: this.$t('teacher.education.bachelor')
        },
        {
          id: '6',
          name: this.$t('teacher.education.master')
        }
      ]
    },
    // 职称
    getRankTypeHttp() {
      this.rankList = [
        {
          id: '1',
          name: this.$t('teacher.rank.level3')
        },
        {
          id: '2',
          name: this.$t('teacher.rank.level2')
        },
        {
          id: '3',
          name: this.$t('teacher.rank.level1')
        },
        {
          id: '4',
          name: this.$t('teacher.rank.senior')
        },
        {
          id: '5',
          name: this.$t('teacher.rank.fullSenior')
        }
      ]
    },
    // 专业
    professionMapHttp() {
      getAdminOrgList().then(res => {
        if (res.code == 200) {
          for (let item of res.data.list) {
            this.professionList.push({
              value: item.id,
              label: item.name,
              children: item.child.map(items => {
                return {
                  value: items.id,
                  label: items.name,
                  children: items.child.map(itemt => {
                    return {
                      value: itemt.id,
                      label: itemt.name
                    }
                  })
                }
              })
            })
          }
          for (let item of this.professionList) {
            if (item.children.length == 0) {
              item.disabled = true
            } else if (item.children.length > 0) {
              for (let items of item.children) {
                if (items.children.length == 0) {
                  items.disabled = true
                }
              }
            }
          }
        }
      })
    },
    onChange(value) {
      console.log(value)
    },
    // 手机号输入处理 - 只允许输入数字
    handlePhoneInput(e) {
      const value = e.target.value
      // 替换非数字字符
      const newValue = value.replace(/\D/g, '')
      if (value !== newValue) {
        e.target.value = newValue
        // 触发表单验证
        this.form.setFieldsValue({ phone: newValue })
      }
    },
    // 手机号验证
    validatePhone(rule, value, callback) {
      const phoneRegex = /^1[3-9]\d{9}$/
      if (value && !phoneRegex.test(value)) {
        callback(this.$t('teacher.invalidMobile'))
      } else {
        callback()
      }
    },
    // 日期禁用函数 - 禁用大于今天的日期
    disabledDate(current) {
      return current && current > moment().endOf('day')
    },
    // 邮箱验证
    validateEmail(rule, value, callback) {
      if (!value) {
        callback()
        return
      }

      // 基本邮箱格式验证
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
      if (!emailRegex.test(value)) {
        callback(this.$t('teacher.invalidEmail'))
        return
      }

      // 验证是否包含常用邮箱后缀
      const atIndex = value.indexOf('@')
      const emailSuffix = value.substring(atIndex)
      if (!this.emailSuffixes.includes(emailSuffix)) {
        callback(this.$t('teacher.invalidEmailSuffix'))
        return
      }

      callback()
    }
    // 工号唯一性验证
    // validateJobNumber(rule, value, callback) {
    //   console.log(rule, value, callback)
    //   if (!value) {
    //     callback()
    //     return
    //   }

    //   validateJobNumber({ employeeNumber: value, id: this.id }).then(res => {
    //     if (res.code === 200) {
    //       if (res.data.exists) {
    //         callback('该工号已存在，请重新输入')
    //       } else {
    //         callback()
    //       }
    //     } else {
    //       callback('工号验证失败，请重试')
    //     }
    //   }).catch(() => {
    //     callback('工号验证失败，请重试')
    //   })
    // }
  },
  mounted() {
    this.id = this.$route.query.id || undefined
    this.getEducationTypeHttp()
    this.getRankTypeHttp()
    this.professionMapHttp()
    this.agefn()
    if (this.id) {
      this.getTeacherDetail()
      setTimeout(() => {
        this.isRequired = false
      }, 100)
    }
  }
}
</script>

<style lang="less" scoped>
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}

.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;

  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }

  .down {
    width: 10px;
    margin-left: 5px;
  }
}

/deep/ .ant-input-suffix {
  right: 12px;

  img {
    width: 23px;
    cursor: pointer;
  }
}

.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;

  img {
    height: 10px;
    margin-right: 9px;
  }
}

/deep/ .ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;

    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }

  .list {
    display: flex;
    padding-right: 200px;

    .ant-form-item-label label {
      color: #000000;
    }

    .ant-form-item {
      width: 50%;
      padding-left: 45px;

      &:first-child {
        padding-left: 0;
        padding-right: 45px;
      }
    }

    .ant-input-affix-wrapper .ant-input-suffix {
      position: absolute;

      img {
        width: 23px;
        height: 23px;
        opacity: 0.3;
      }
    }

    .ant-calendar-picker div {
      position: relative;
    }

    .ant-input,
    .ant-select {
      border-radius: 4px;
      color: #000000;
    }

    .full .ant-input,
    .full .ant-select {
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      border-radius: 4px;
    }
  }

  .submit-button {
    width: 100%;
    // padding-left: 500px;
    text-align: center;
    margin-top: 100px;
  }
}
/deep/ .anticon {
  color: #d5d5d5 !important;
}

// 添加日期选择器样式
.ant-calendar-picker {
  width: 100%;
}
</style>
